import { useDispatch } from 'react-redux'
import { setRefreshTrigger } from 'store/cards';

export const useRefreshItems = () => {
  const dispatch = useDispatch();

  const refresh = () => {
    dispatch(setRefreshTrigger());
};

return refresh;
}
